import { render } from "./ChooseProviderDialog.vue?vue&type=template&id=8827bab0&scoped=true"
import script from "./ChooseProviderDialog.vue?vue&type=script&lang=js"
export * from "./ChooseProviderDialog.vue?vue&type=script&lang=js"

import "./ChooseProviderDialog.vue?vue&type=style&index=0&id=8827bab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8827bab0"]])

export default __exports__